import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Cushion, FlexContainer, Grid, Rectangle, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import IconWithTheme from '../icon-with-theme';
import ProfileLink from './profile-link';
import MatchEventIcon from './match-event-icon';

const Selection = ({
  avatar,
  events,
  name,
  number,
  playerId,
  position,
  teamId,
  captain,
  wicketKeeper,
}) => {
  function isCaptin() {
    if (captain) {
      return <Icon name="captain" size={20} />;
    }
    return '';
  }

  function isWicketKeeper() {
    if (wicketKeeper) {
      const wicketKeeperSvg = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 296 289"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0H296V289H0V0Z" fill="white" />
          <path
            d="M273 144C273 211.379 216.812 266 147.5 266C78.1883 266 22 211.379 22 144C22 76.6213 78.1883 22 147.5 22C216.812 22 273 76.6213 273 144Z"
            fill="black"
          />
          <path
            d="M63.9912 195.728L36.0389 96.3535H48.6174L69.9809 177.289H70.9792L92.7421 96.3535H106.718L128.481 177.289H129.479L150.843 96.3535H163.421L135.469 195.728H122.691L100.129 116.539H99.3308L76.7693 195.728H63.9912Z"
            fill="white"
          />
          <path
            d="M178.845 195.728V96.3535H191.224V145.653H192.422L238.343 96.3535H254.516L211.589 141.188L254.516 195.728H239.541L204.002 149.534L191.224 163.509V195.728H178.845Z"
            fill="white"
          />
        </svg>
      );
      return wicketKeeperSvg;
    }
    return '';
  }

  return (
    <ProfileLink name={name} playerId={playerId} teamId={teamId}>
      <Rectangle fill="white" borderTop="thinLightGrey">
        <Cushion vertical="small" horizontal="medium">
          <Grid
            className="grid-icon-label"
            columns={`40px auto 1fr ${events.length ? `repeat(${events.length}, 36px)` : ''}`}
            alignItems="center"
            columnGap="small"
          >
            <Avatar
              image={avatar}
              includeRetina
              alt={name}
              size={42}
              radius="10px"
              style={{ maxWidth: '100%' }}
            />
            <Rectangle
              fill="#eee"
              component="div"
              radius="100%"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '28px',
                height: '28px',
              }}
            >
              {number}
            </Rectangle>
            <FlexContainer flexDirection="column" justifyContent="center">
              <Typography preset="subtitle--small" component="div" color="black">
                {`${name}`}
                {isCaptin()}
                {isWicketKeeper()}
              </Typography>
              {position && (
                <Typography preset="description" color="dustygrey">
                  {position}
                </Typography>
              )}
            </FlexContainer>
            {events
              .filter((event) => event.icon)
              .map((event) => (
                <div style={{ textAlign: 'center' }} key={event.id}>
                  <IconWithTheme>
                    <MatchEventIcon {...event.icon} fontColour="black" size={18} />
                  </IconWithTheme>
                  <Typography preset="description" color="dustygrey" component="div" align="center">
                    {event.time}
                  </Typography>
                </div>
              ))}
          </Grid>
        </Cushion>
      </Rectangle>
    </ProfileLink>
  );
};

Selection.defaultProps = {
  position: null,
  captain: false,
  wicketKeeper: false,
};

Selection.propTypes = {
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  position: PropTypes.string,
  teamId: PropTypes.number.isRequired,
  playerId: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      eventTypeId: PropTypes.number,
      time: PropTypes.string,
    }),
  ).isRequired,
  captain: PropTypes.bool,
  wicketKeeper: PropTypes.bool,
};

export default Selection;
